"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var http_1 = require("@angular/common/http");
var base_service_1 = require("../base-service");
var alertminer_api_configuration_1 = require("../alertminer-api-configuration");
var operators_1 = require("rxjs/operators");
var i0 = __importStar(require("@angular/core"));
var i1 = __importStar(require("../alertminer-api-configuration"));
var i2 = __importStar(require("@angular/common/http"));
var DealerRatesClientService = /** @class */ (function (_super) {
    __extends(DealerRatesClientService, _super);
    function DealerRatesClientService(config, http) {
        return _super.call(this, config, http) || this;
    }
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerRateMarkUpsByDealeridGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerRates/GetDealerRateMarkUps/" + dealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerRateMarkUpsByDealeridGET = function (dealerId) {
        return this.GetDealerRateMarkUpsByDealeridGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     */
    DealerRatesClientService.prototype.UpdateDealerUsedRatesPOSTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/DealerRates/UpdateDealerUsedRates", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     */
    DealerRatesClientService.prototype.UpdateDealerUsedRatesPOST = function (data) {
        return this.UpdateDealerUsedRatesPOSTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.DeleteAllUsedRatesByDealerIdPOSTResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = dealerId;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/DealerRates/DeleteAllUsedRatesByDealerId", __body, {
            headers: __headers,
            params: __params,
            responseType: 'text'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r.clone({ body: _r.body === 'true' });
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.DeleteAllUsedRatesByDealerIdPOST = function (dealerId) {
        return this.DeleteAllUsedRatesByDealerIdPOSTResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param data undefined
     */
    DealerRatesClientService.prototype.UpdateDealerOverAllowancePOSTResponse = function (data) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = data;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/DealerRates/UpdateDealerOverAllowance", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param data undefined
     */
    DealerRatesClientService.prototype.UpdateDealerOverAllowancePOST = function (data) {
        return this.UpdateDealerOverAllowancePOSTResponse(data).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param rates undefined
     */
    DealerRatesClientService.prototype.UpdateDealerRateMarkUpsPOSTResponse = function (rates) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        __body = rates;
        var req = new http_1.HttpRequest('POST', this.rootUrl + "/api/DealerRates/UpdateDealerRateMarkUps", __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param rates undefined
     */
    DealerRatesClientService.prototype.UpdateDealerRateMarkUpsPOST = function (rates) {
        return this.UpdateDealerRateMarkUpsPOSTResponse(rates).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerOverAllowancesByDealeridGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerRates/GetDealerOverAllowances/" + dealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerOverAllowancesByDealeridGET = function (dealerId) {
        return this.GetDealerOverAllowancesByDealeridGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerUsedRatesByDealeridGETResponse = function (dealerId) {
        var __params = this.newParams();
        var __headers = new http_1.HttpHeaders();
        var __body = null;
        var req = new http_1.HttpRequest('GET', this.rootUrl + ("/api/DealerRates/GetDealerUsedRates/" + dealerId), __body, {
            headers: __headers,
            params: __params,
            responseType: 'json'
        });
        return this.http.request(req).pipe(operators_1.filter(function (_r) { return _r instanceof http_1.HttpResponse; }), operators_1.map(function (_r) {
            return _r;
        }));
    };
    /**
     * @param dealerId undefined
     * @return Success
     */
    DealerRatesClientService.prototype.GetDealerUsedRatesByDealeridGET = function (dealerId) {
        return this.GetDealerUsedRatesByDealeridGETResponse(dealerId).pipe(operators_1.map(function (_r) { return _r.body; }));
    };
    DealerRatesClientService.GetDealerRateMarkUpsByDealeridGETPath = '/api/DealerRates/GetDealerRateMarkUps/{dealerId}';
    DealerRatesClientService.UpdateDealerUsedRatesPOSTPath = '/api/DealerRates/UpdateDealerUsedRates';
    DealerRatesClientService.DeleteAllUsedRatesByDealerIdPOSTPath = '/api/DealerRates/DeleteAllUsedRatesByDealerId';
    DealerRatesClientService.UpdateDealerOverAllowancePOSTPath = '/api/DealerRates/UpdateDealerOverAllowance';
    DealerRatesClientService.UpdateDealerRateMarkUpsPOSTPath = '/api/DealerRates/UpdateDealerRateMarkUps';
    DealerRatesClientService.GetDealerOverAllowancesByDealeridGETPath = '/api/DealerRates/GetDealerOverAllowances/{dealerId}';
    DealerRatesClientService.GetDealerUsedRatesByDealeridGETPath = '/api/DealerRates/GetDealerUsedRates/{dealerId}';
    DealerRatesClientService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DealerRatesClientService_Factory() { return new DealerRatesClientService(i0.ɵɵinject(i1.AlertminerApiConfiguration), i0.ɵɵinject(i2.HttpClient)); }, token: DealerRatesClientService, providedIn: "root" });
    return DealerRatesClientService;
}(base_service_1.BaseService));
exports.DealerRatesClientService = DealerRatesClientService;
